<template>
  <div id="app">
    <!-- 路由出口 -->
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view v-if="isRouterAlive" style="min-height: 100%"></router-view>
    <!--對所有頁面返回頂部，不屏蔽-->
    <div v-if="this.IsMobile() != null">
      <Backtotop :visibility-height="300" :back-position="250" :class_name="'el-main'" ref="ToTop" />
    </div>
    <div v-else>
      <el-tooltip placement="top" content="返回頂部">
        <Backtotop :visibility-height="300" :back-position="250" :class_name="'el-main'" ref="ToTop" />
      </el-tooltip>
    </div>
  </div>
</template>
<script>
import Backtotop from '@/components/backtotop/Index.vue'
export default {
  name: "App",
  components: { Backtotop },
  metaInfo: {
    meta: [
      {
        httpEquiv: 'Cache-Control',
        content: 'no-cache, no-store, must-revalidate'
      },
      {
        httpEquiv: 'Pragma',
        content: 'no-cache'
      },
      {
        httpEquiv: 'Expires',
        content: '0'
      },
    ],
  },
  data() {
    return {
      isRouterAlive: true, //用于刷新当前路由
    };
  },
  //用于刷新当前路由
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    //用于刷新当前路由(后续可能会用到)
    //使用方式:default中inject:['reload']---调用方式:this.reload
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    }
  },
};
</script>
<style>
html,
body,
h3,
p {
  margin: 0;
  padding: 0;
}

/* 全局表单样式 */

.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
.el-form-item {
  margin-bottom: 5px;
}

.el-form-item--small {

  .el-form-item__label {
    font-weight: bold;
    line-height: 26px;
  }

  .el-form-item__content {
    line-height: 26px;
  }
}

.el-form-item__label {
  font-weight: bold;
  line-height: 26px;
}

.el-form-item__content {
  line-height: 26px;
}

/* 全局多选下拉框颜色块 */
.el-tag.el-tag--info {
  /*   background-color: #409EFF;
  border-color: #409EFF; */
  color: #FFF;
}

.el-select .el-tag__close.el-icon-close {
  background-color: #FFF;
}

#app {
  height: 100vh;
}

/* 上右 */
.el-card__body {
  padding: 15px 18px 0px 0px;
}

/* 全局删除提示框宽度 */
.el-message-box {
  width: 300px;
}

/* 設置全局字體大小(全部頁面) */
/* .el-form-item__label,
.el-checkbox__label,
table,
span,
h3,
.el-dropdown-menu__item,
.el-tooltip__popper,
.el-tag--small,
.el-input__inner,
.el-dialog__title
{
  font-size: 20px;
}  */
/* 子菜单、驗證空、氣泡、成功提示字体 */
.el-menu-item,
.el-form-item__error,
.el-tooltip__popper,
.el-message__content,
/*  默認彈窗提示16px */
.el-message-box__message,
/*  默認彈窗按鈕16px */
.el-message-box__btns span {
  font-size: 16px;
}

/* 默認時間下拉字體 */
.el-time-spinner__item,
.el-time-panel__btn {
  font-size: 18px;
}

/* 樹菜單滾動條 */
.el-scrollbar__thumb {
  height: 100%;
}

/* Cascader 级联选择器，不顯示radio */
.SelectNoRadio {
  .el-radio__inner {
    top: -18px;
    left: -19px;
    border-radius: 0;
    border: 0;
    width: 170px;
    height: 34px;
    background-color: transparent;
    cursor: pointer;
    box-sizing: border-box;
    position: absolute;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: transparent;
  }
}

.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
  padding: 0px 10px;
}

.el-scrollbar__wrap {
  margin-bottom: 0 !important;
}

/*日曆控件格式 
.el-calendar__header .el-calendar__title {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    font-size: 20px;
    color: #4e8cda;
}

.el-calendar__button-group {
    width: 100%;
}

.el-button-group {
    display: flex;
    justify-content: space-between;
}

.el-button-group::after, .el-button-group::before {
    content: unset;
}

.el-button-group>.el-button:not(:first-child):not(:last-child) {
    display: none;
}

.el-button-group>.el-button:first-child:before{
    content: '<';
}

.el-button-group>.el-button:last-child:before{
    content: '>';
}

.el-button-group>.el-button:first-child span, .el-button-group>.el-button:last-child span{
    display: none;
}
日曆控件格式 End*/

.el-button-group {
  display: flex;
  justify-content: space-between;
}

.el-button-group::after,
.el-button-group::before {
  content: unset;
}

.el-button-group>.el-button:first-child:before {
  content: '<';
}

.el-button-group>.el-button:not(:first-child):not(:last-child):before {
  content: '•';
}

.el-button-group>.el-button:last-child:before {
  content: '>';
}

.el-button-group>.el-button:not(:first-child):not(:last-child) span {
  display: none;
}

.el-button-group>.el-button:first-child span,
.el-button-group>.el-button:last-child span {
  display: none;
}
.el-form-item__error {
  position: relative;
}
.el-table { color: black }

.el-input__inner, .el-textarea__inner {
  border: 1px solid #666;
}
</style>
